export default "__VITE_ASSET__jpubiMep__"